import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getPagesContactCentreDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
    footerContactInfo:[
      {
        fieldName: "Page Title",
        fieldValue: "pageTitle",
        className: "col-span-6",
        type: "text",
        name: "pageTitle",
        formType: "input",
        label: "Page Title",
        placeholder: "Enter Page Title",
        validation: { required: "Page Title is required" },
      },
      {
          fieldName: "Menu Title (EN)",
          fieldValue: "titleEnglish",
          className: "col-span-6",
          type: "text",
          name: "titleEnglish",
          formType: "input",
          label: "Menu Title (EN)",
          placeholder: "Enter Menu Title (EN)",
          validation: { required: "Menu Title (EN) is required" },
      },
      {
          fieldName: "Menu Title (MS)",
          fieldValue: "titleMalay",
          className: "col-span-6",
          type: "text",
          name: "titleMalay",
          formType: "input",
          label: "Menu Title (MS)",
          placeholder: "Enter Menu Title (MS)",
          // validation: { required: "Menu Title (MS) is required" },
      },
      {
          fieldName: "Menu Title (ZH)",
          fieldValue: "titleMandarin",
          className: "col-span-6",
          type: "text",
          name: "titleMandarin",
          formType: "input",
          label: "Menu Title (ZH)",
          placeholder: "Enter Menu Title (ZH)",
          // validation: { required: "Menu Title (ZH) is required" },
      },
      {
          fieldName: "Content (EN)",
          fieldValue: "addressEnglish",
          className: "col-span-6",
          type: "content",
          name: "addressEnglish",
          formType: "richText",
          label: "Content (EN)",
          placeholder: "Enter Content (EN)",
          validation: { required: "Content (EN) is required" },
      },
      {
          fieldName: "Content (MS)",
          fieldValue: "addressMalay",
          className: "col-span-6",
          type: "content",
          name: "addressMalay",
          formType: "richText",
          label: "Content (MS)",
          placeholder: "Enter Content (MS)",
          // validation: { required: "Content (MS) is required" },
      },
      {
          fieldName: "Content (ZH)",
          fieldValue: "addressMandarin",
          className: "col-span-6",
          type: "content",
          name: "addressMandarin",
          formType: "richText",
          label: "Content (ZH)",
          placeholder: "Enter Content (ZH)",
          // validation: { required: "Content (ZH) is required" },
      },
    ],
  privacyPolicy:[
    {
        fieldName: "Content (English)",
        fieldValue: "data.title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_title",
        formType: "richText",
        label: "Content (English)",
        placeholder: "Enter Content (English)",
        validation: { required: "Content (English) is required" },
      },
  ],
 
};
